module.exports = __webpack_public_path__ + "static/media/canada_alaska_1.ea4c4dff.jpg";